import Api from 'api/api';

class BudgetItemApi {
    post({year, month, amount, category}) {
        return Api.post('/budget_items', {
            year, month, amount, category,
        });
    }

    put(id, {amount}) {
        return Api.put(`/budget_items/${id}`, {amount});
    }

    delete(id, includeTransactions = false) {
        if (includeTransactions) {
            return Api.delete(`/budget_items/${id}`, {params: {deleteTransactions: 1}});
        } else {
            return Api.delete(`/budget_items/${id}`);
        }
    }
}

export default new BudgetItemApi();


// WEBPACK FOOTER //
// ./src/api/budget-item.js